import React from "react";
import clsx from "clsx";
import AddButtonNew from "../../AddButton/AddButtonNew";
import NumberSpinner from "../../NumberSpinner/NumberSpinner";

class RateBuilderProducts extends React.Component {

  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this)
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.errors) {
      this.setState({errors: nextProps.errors})
    }
  }

  render() {
    var tabClasses = clsx({
      'active': this.props.active_tab == 'products',
      'tab-pane': true
    })
    var self = this;

    var products = this.props.products.map((product) => {
    var rate_product = self.getRateProduct(product)
      return (
        <div key={product.id}>
        <div className="row guest-type" key={product.id}>
          <div className="col-md-3 name-wrapper">
            <div className="form-group">
              <label>{I18n.t('product')}</label>
              <div>{product.name}</div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="form-group">
              <label>{I18n.t('quantity')}</label>
              <NumberSpinner
                onChange={self.onChange}
                name={product.id + '|quantity'}
                min={0}
                value={rate_product ? (rate_product.quantity || 1) : 1} className="form-control" />
            </div>
          </div>
            <div className="col flexed content-right">
            <button type="button" className={"btn btn-secondary btn-sm remove-product-btn"} onClick={this.props.onRemoveProduct.bind(this, product.id)}  >
              {I18n.t('remove')}
            </button>
          </div>
        </div>
          {this.props.products.length > 1  ? <hr /> : null}
        </div>
      )
    })

    return(
      <div className={tabClasses} id="products">
          <div className="panel panel-default" style={{ marginBottom: 0 }}>
            <div className="panel-heading flexed add-button-pannel">
              <div className="col-md-6" >
                <h3 className="panel-title">{I18n.t('products_included_with_the_rate')}<span className="ss-help help" title={I18n.t('rate_products_helper_text')}></span>   </h3>
              </div>
              <div className="col-md-6 content-right flexed">
                <AddButtonNew
                  model="Product" 
                  column="name" 
                  ids={this.props.products ? this.props.products.map((product) => { return product.id; }) : null} 
                  onAdd={this.props.onAddProduct} text={I18n.t('add')} 
                  buttonClasses="btn btn-secondary" 
                  new_button={false}
                  generalPosition="left"
                />
              </div>
            </div>
            <div className="panel-body container">
              <div className={"products "}>
                {products && products.length ? products : <div className="no-records"><span className="none">{I18n.t('none')}</span></div>}
              </div>
            </div>
          </div>
      </div>
    )
  }

  getRateProduct(product) {
    if (this.props.rate_products && this.props.rate_products.length) {
      for (var i = 0, ilen = this.props.rate_products.length; i < ilen; i++) {
        if (this.props.rate_products[i].product_id == product.id) {
          return this.props.rate_products[i];
        }
      }
    }

    return null
  }

  onChange(event) {
    if (event && event.target) {

      var product_id = event.target.name.split('|')[0]
      var name = event.target.name.split('|')[1]

      if (this.props.rate_products && this.props.rate_products.length) {
        var found_match = false
        for (var i = 0, ilen = this.props.rate_products.length; i < ilen; i++) {
          if (this.props.rate_products[i].product_id == product_id) {
            this.props.rate_products[i][name] = event.target.value
            found_match = true
            break
          }
        }
        if (!found_match) {
          var rate_product = {
            product_id: product_id
          }
          rate_product[name] = event.target.value
          this.props.rate_products.push(rate_product)
        }
      } else {
        var rate_product = {
          product_id: product_id
        }
        rate_product[name] = event.target.value
        this.props.rate_products.push(rate_product)
      }

      if (typeof this.props.onChange == 'function') {
        this.props.onChange({
          target: {
            name: 'rate_products',
            value: this.props.rate_products
          }
        })
      }
    }
  }

}

export default RateBuilderProducts
